import axios from 'axios';

export const API_URL = 'https://montenegromice.com/mice-api';

export const fetchPhotoGalleries = () => {
  return axios.get(`${API_URL}/coworking/photo-gallery`)
    .then(response => response.data)
    .catch(error => {
      throw new Error(error.message);
    });
};

export const deletePhotoGallery = (photoGalleryId) => {
    return axios.delete(`${API_URL}/coworking/photo-gallery/${photoGalleryId}`)
      .then(response => response.data)
      .catch(error => {
        throw new Error(`Greška pri brisanju: ${error.message}`);
      });
  };

  export const getPhotoGallery = async (id) => {
    try {
      const response = await axios.get(`${API_URL}/coworking/photo-gallery/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(`Greška pri dobavljanju: ${error.message}`);
    }
  };

  export const editPhotoGallery = async (id, photoGalleryData) => {
    try {
      const response = await axios.put(`${API_URL}/coworking/photo-gallery/${id}`, photoGalleryData);
      return response.data;
    } catch (error) {
      throw new Error(`Greška pri editovanju: ${error.message}`);
    }
  };

  export const addPhotoGallery = (photoGalleryData) => {
    return axios.post(`${API_URL}/coworking/photo-gallery`, photoGalleryData)
      .then(response => response.data)
      .catch(error => {
        throw new Error(`Greška pri dodavanju: ${error.message}`);
      });
  };
